import { render, staticRenderFns } from "./UpdateData.vue?vue&type=template&id=79475f65&"
import script from "./UpdateData.vue?vue&type=script&lang=js&"
export * from "./UpdateData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports